import { format, parseISO } from 'date-fns';

const formatDate = date => format(typeof date === 'string' ? parseISO(date) : date, 'MMMM d, y');

export default formatDate;
